// extracted by mini-css-extract-plugin
export default {"BigPicWrapper":"BigPic_BigPicWrapper__fQEc9"};